import { render, staticRenderFns } from "./dashboardContentBox.vue?vue&type=template&id=6044a5f0&scoped=true&"
import script from "./dashboardContentBox.vue?vue&type=script&lang=js&"
export * from "./dashboardContentBox.vue?vue&type=script&lang=js&"
import style0 from "./dashboardContentBox.vue?vue&type=style&index=0&id=6044a5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044a5f0",
  null
  
)

export default component.exports